import { OptionProps, OptionsGroup, SelectFieldProps } from '../SelectField.types'

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function filterOptionsByInput<OptionValueType>(
  options: OptionProps<OptionValueType>[],
  inputValue: string,
  filterOption?: SelectFieldProps<OptionValueType>['filterOption'],
) {
  if (filterOption) {
    return options.filter(option => filterOption(option, inputValue))
  }

  if (!inputValue) {
    return options
  }

  const escapedInputValue = escapeRegExp(inputValue)
  const regex = new RegExp(escapedInputValue, 'i')

  return options.filter(
    option =>
      (option.value && regex.test(option.value.toString())) ||
      (option.label && typeof option.label === 'string' && regex.test(option.label)) ||
      (option.subtitle && regex.test(option.subtitle)) ||
      (option.searchTerm && regex.test(option.searchTerm)),
  )
}

export function hasOptionsGrouping<OptionValueType>(
  optionsOrGroups: OptionProps<OptionValueType>[] | OptionsGroup<OptionValueType>[],
): optionsOrGroups is OptionsGroup<OptionValueType>[] {
  return optionsOrGroups.length > 0 && Object.hasOwn(optionsOrGroups[0], 'options')
}
